import React, {useCallback} from 'react'
import {Image} from 'react-bootstrap'
import k1utils from '../../../../util/k1utils'
import {updateOrder2} from "../../Wizard/_redux/wizardCrud";
import {useHistory} from 'react-router-dom'

export function NotificationOrderForm2({data, order_key}) {
  const {name, idx, description, soldout} = data
  const backgroundImageUrl = k1utils.toSmallFileUrl(data.t_fileidx)
  const history = useHistory()
  const onClick = useCallback(() => {
    
    if (soldout === 'Y') {
      return;
    }
    // order_key 의 form 을 설정합니다. 
    const updateData = {
      order_key: order_key,
      t_order_formidx: idx,
    }
    updateOrder2(updateData)
      .then(() => {
        history.push(`/o/${order_key}/${idx}`)
      })
      .catch((err) => console.error(err))
  }, [history, order_key, idx])
  const preStyle = {
    whiteSpace: 'pre-wrap',
    flexBasis: '40%',
    height: 145,
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  }

  return (
    <div
      className='card card-custom d-flex p-3 border flex-row mb-2'
      onClick={onClick}
      style={{cursor: 'pointer'}}
    >
      <div style={{flexBasis: '60%'}}>
        <Image src={backgroundImageUrl} rounded width={175} height={175} />
      </div>
      <div className='ml-3 w-100'>
        {/*<div className="mb-1">*/}
        <h4 className='mb-1'>{name} 
        {
          soldout === 'Y' ? 
          (<span className='badge badge-sm badge-danger ml-2'>품절</span>) 
          : 
          null
        }
          </h4>
        {/*</div>*/}
        <pre style={preStyle}>{description}</pre>
      </div>
    </div>
  )
}
